<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark>予約</v-toolbar>
        <v-card-title class="noPaddingBtm">
          <v-col cols="6" class="noPadding">
            {{this.viewTime}}
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-card-text>
            <v-container style="height: 216px;overflow-y: auto;">
              <v-row v-for="(item, index) in contentValue" :key="index">
                <v-col cols="7">
                  <v-subheader :style="GetBgRGB(index)">
                    <div class="MenuStyle">
                      {{item.menu}}
                    </div>
                  </v-subheader>
                </v-col>
                <v-col cols="5" style="padding: 12px 0px;">
                  <v-subheader>
                    <v-icon large color="blue" v-if="item.reserve_flg" @click="reserveFlgChange(item)">
                      mdi-check-circle
                    </v-icon>
                    <v-icon large v-if="!item.reserve_flg" @click="reserveFlgChange(item)">
                      mdi-checkbox-blank-circle-outline
                    </v-icon>
                    {{item.meal_name}}
                  </v-subheader>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :disabled="closeBtnCtrl" :iconCls="'mdi-close'">
            </ryou-black-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

  export default {
    name: "MealReservationDayDialog",
    components: {
      RyouBlackBtn
    },
    data() {
      return {
        dialog: false,
        closeBtnCtrl: false,
        time: "",
        viewTime: "",
        contentValue: [],
        groupOptionValue: "",
        reserveUserOptionValue: "",
      };
    },
    watch: {
    },
    methods: {
      //クリックを閉じる
      handleCancel() {
        this.close();
      },
      //ページローディング要求インターフェース、取得値
      // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID
      getInputValue(value, buildGroupSelectValue, reserveUserSelectValue) {

        if (buildGroupSelectValue) {
          this.groupOptionValue = buildGroupSelectValue;
        }
        if (reserveUserSelectValue) {

          this.reserveUserOptionValue = reserveUserSelectValue;
        }
        //タイプ判定
        if (value instanceof Object) {

          for (let dialogDataIndex in value) {
            this.time = dialogDataIndex;

            let timelist = dialogDataIndex.split("-");
            this.viewTime =
              timelist[0] + "/"
              + (timelist[1][0] == "0" ? timelist[1][1] : timelist[1]) + "/"
              + (timelist[2][0] == "0" ? timelist[2][1] : timelist[2]);

            this.contentValue = value[dialogDataIndex];
            if (this.contentValue.length != 0) {
              this.contentValue.forEach((item) => {

                item.reserve_flg = item.reserve_flg == "" ? false : Boolean(Number(item.reserve_flg));
              });
            }
          }
        }

        this.open();
      },
      // パラメータをクリア
      clearParameters() {

        this.contentValue = [];
        this.groupOptionValue = "";
        this.reserveUserOptionValue = "";
      },
      close() {
        this.dialog = false;

        this.clearParameters();
        this.$emit("reCalendar");
      },
      open() {
        this.dialog = true;
      },
      GetBgRGB(value) {
        let BgRGB = [
          "#FF9800",//オレンジ
          "#673AB7",//深紫
          "#4CAF50",//緑
          "#E91E63",//ピンク
          "#3F51B5",//インディゴ
          "#009688",//teal
          "#FF5722",//深オレンジ
          "#8BC34A",//light-green
          "#D32F2F",//red darken-2
          "#1565C0"//blue darken-3
        ]
        return {
          background: BgRGB[value]
        };
      },
      reserveFlgChange(value) {

        value.reserve_flg = !value.reserve_flg;

        let params = {
          build_group_id: this.groupOptionValue,
          input_date: this.time,
          edit_user_id: this.reserveUserOptionValue,
          reserve_entity: [{
            meal_class: value.meal_class,
            reserve_flg: Number(value.reserve_flg).toString()
          }],
          user_id: this.$store.getters.getUserId
        };

        this.closeBtnCtrl = true;
        this.putRequest("/mealReservation/mealReserveUpdate", params, this.$store.getters.getUserToken).then(() => {

          this.closeBtnCtrl = false;
        });
      }
    }
  }
</script>

<style scoped>
  .noPadding {
    padding: 0px;
  }

  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .noPaddingTopBtm {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .HigotoTextBox {
    outline: 1px solid rgb(0, 225, 255);
  }

  .MenuStyle {
    width: 100%;
    height: 100%;
    color: white;
    font-weight: bold;
    text-align: center;
    line-height: 48px;
  }
</style>